import React, { useState, useMemo, Fragment, useEffect } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import Interface from './InterfaceComponents/Interface';
import GhostText from './GhostText';
import xlsx from './questions.xls';

function App() {
  const allQuestions = useAllQuestions(xlsx);
  const [listQuestions, changelistQuestions] = useListQuestions();
  useEffect(() => {
    changelistQuestions(allQuestions);
  }, []);

  if (!listQuestions) {
    return <Fragment />;
  }
  return (
    <Router>
      <Interface
        questions={listQuestions}
        onReset={() => {
          changelistQuestions(allQuestions);
        }}
        //
      />
      <GhostText allQuestions={allQuestions} />
    </Router>
  );
}

export default App;

const useAllQuestions = () => {
  const dataArray = useMemo(() => {
    const _dataArray = [];
    const data = xlsx[0].data;
    data.forEach((val, index) => {
      if (!val[1]) return;
      const obj = {
        index: index,
        number: val[0], //問題番号
        title: val[1], //問題文
        choices: [val[2], val[3], val[4], val[5]], //選択肢
        correct: val[8],
        comment: val[6],
      };
      _dataArray.push(obj);
    });
    return _dataArray;
  }, []);
  return dataArray;
};

const useListQuestions = () => {
  const rangeArr = [
    [0, 9],
    // [9, 15], //春
    //[15, 21], //夏
    //[21, 27], //秋
    [27, 33], //冬
    [33, 48],
  ]; //問題全体から抽出する範囲(index値)
  const numberArr = [3, 2, 5]; //rangeArrから抽出する数
  const [data, setData] = useState();

  const setDataFromAll = (arr) => {
    const _dataArray = [];
    rangeArr.forEach((val, index) => {
      _dataArray.push(...randomSelect(arr.slice(val[0], val[1]), numberArr[index]));
    });
    // console.log(_dataArray);
    setData(_dataArray);
  };

  return [data, setDataFromAll];
};

// 配列arrayからランダムにnum個の要素を取り出す(currentNumbers以外で)
function randomSelect(array, num) {
  let newArray = [];
  while (newArray.length < num && array.length > 0) {
    // 配列からランダムな要素を選ぶ
    const rand = Math.floor(Math.random() * array.length);
    // 選んだ要素を別の配列に登録する
    newArray.push(array[rand]);
    // もとの配列からは削除する
    array.splice(rand, 1);
  }
  return newArray;
}
